import * as Sentry from "@sentry/vue";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (idSupplier, idMessage) {
  const routeLang = useRouteLang();

  try {
    return await $apiFetch(API_ENDPOINTS.SUPPLIER_ID_MESSAGE_ID_TRANSLATION, {
      method: 'GET',
      path: { idSupplier, idMessage },
      params: {
        locale: routeLang.locale.value
      }
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
}
